export default __webpack_public_path__ + "static/media/MilkTeaPouring3.02dd32bf.jpg";